import React from 'react';
import PeptideCalculatorTemplate from '../components/PeptideCalculatorTemplate';
import { PEPTIDE_DATA } from '../data/peptideCalculatorData';

const TirzepatideCalculator = () => {
  return <PeptideCalculatorTemplate peptideData={PEPTIDE_DATA.tirzepatide} />;
};

export default TirzepatideCalculator;
